let documentFirstReferrer = null
let zoomImages = []
let observer = null
let splider = null
let zoomSplider = null

function docReady(fn) {
  if (document.readyState === 'complete' || document.readyState === 'interactive') {
    setTimeout(fn, 1)
  } else {
    document.addEventListener('DOMContentLoaded', fn)
  }
}

docReady(function () {
  renderProduct()
})

const renderProduct = () => {
  renderGallery()

  documentFirstReferrer = document.referrer

  const wishlistButton = document.querySelector('.btn__wishlist')

  isProductInWishlist(wishlistButton)
  wishlistButton.addEventListener('click', e => wishlistManagement(e))
  window.addEventListener('scroll', e => checkIfFooterInViewport(), { passive: true })

  document.getElementById('AddToCartForm').addEventListener('submit', e => addToCart(e))
  document.querySelector('#quickview__main__image').addEventListener('click', e => initPhotoSwipe())

  productInfo.currentProductVariants = []
  productInfo.variants.forEach(item => {
    if (item.product.id.toString() === productInfo.currentProductId.toString()) {
      productInfo.currentProductVariants.push(item)
    }
  })
  const variantId = getVariantId()

  //FILL SFERE COLORI
  if (variantId) {
    createColorSpheres(variantId)
    productInfo.variants.forEach(variant => {
      if (variant.variant.id == variantId) {
        createSizeSpheres(variant.variantInfo.sku_frontend)
      }
    })
  }

  window.addEventListener('popstate', e => {
    e.preventDefault()
    window.location.href = document.referrer
  })

  addMutationObserver('#Product__InfoBox', () => {
    let notifyButton = document.querySelector('.restock-alerts-notify-button')

    if (notifyButton) {
      const formCart = document.querySelector('#AddToCartForm')
      let parentNoty = notifyButton.parentElement
      notifyButton && parentNoty.removeChild(notifyButton)
      formCart.appendChild(notifyButton)
    }
  })
}
const renderGallery = () => {
  splider = new Splide('.product__slider', {
    type: 'loop',
    perPage: 1,
    autoplay: false,
    arrows: false,
    gap: 0,
    pagination: true,
  }).mount()

  zoomSplider = new Splide('.zoom__slider', {
    type: 'loop',
    perPage: 1,
    autoplay: false,
    arrows: true,
    gap: 0,
    pagination: true,
  }).mount()

  Array.from(document.querySelectorAll('.zoom__slider .splide__arrow')).forEach((arrow, index) => {
    index === 0
      ? (arrow.innerHTML =
          " <img src='https://cdn.shopify.com/s/files/1/0572/4798/9919/files/arrowright.svg?v=1623762119' class=' absolute top-1/2 left-1/2 transform -translate-y-1/2 -translate-x-1/2 rotate-180'/>")
      : (arrow.innerHTML =
          " <img src='https://cdn.shopify.com/s/files/1/0572/4798/9919/files/arrowright.svg?v=1623762119' class=' absolute top-1/2 left-1/2 transform -translate-y-1/2 -translate-x-1/2'/>")
  })
}

//FUNZIONE CREAZIONE SFERE E COLORI
const createColorSpheres = variantId => {
  if (!variantId) {
    console.log('no variantId?')
    return
  }

  let selectedColorFirstVariant = null

  selectedColorFirstVariant = productInfo.currentProductVariants.find(item => item.variant.id == variantId)
  productInfo.selectedColor = selectedColorFirstVariant.variantInfo.sku_frontend

  fillQuickViewInitialData(selectedColorFirstVariant)

  try {
    document.querySelector(`[data-color="${productInfo.selectedColor}"]`).classList.remove('border-transparent')
    document.querySelector(`[data-color="${productInfo.selectedColor}"]`).classList.add('border-black')
  } catch (err) {
    // console.log(err)
  }

  const wishlistButton = document.querySelector('.btn__wishlist')
  wishlistButton.setAttribute('data-id', selectedColorFirstVariant.variant.id)
  isProductInWishlist(wishlistButton)

  document.getElementById('AddToCart').classList.remove('hidden')
  document.getElementById('AddToCart').disabled = true
  document.getElementById('AddToCart').classList.add('bg-dark-gray')
  document.getElementById('AddToCart').classList.remove('bg-black')
  document.getElementById('AddToCart').setAttribute('data-redirect', 'false')
  document.getElementById('AddToCart').innerHTML = productTranslations.addToCart
}

getVariantId = () => {
  const urlVariantInfo = new URL(window.location.href)
  return urlVariantInfo.searchParams.get('variant') || productInfo.variants[0].variant.id
}

const isMultiSize = size => {
  const sizeMatch = new RegExp('\\d+\\w\\d+')
  return size.includes('-') || sizeMatch.test(size)
}

const createSizeSpheres = (color, selectSize = true) => {
  //FILL SFERE TAGLIE
  const sizes = []

  productInfo.currentProductVariants.forEach(variant => {
    if (variant.variantInfo.sku_frontend == color) {
      // console.log(variant.variantInfo)
      sizes.push({
        index: +variant.variantInfo.index,
        size: variant.variant.option1,
        available: variant.variant.available,
      })
    }
  })

  // console.log('sizes')
  // console.log(sizes)

  document.getElementById('AddToCart').disabled = true
  document.getElementById('AddToCart').classList.add('bg-dark-gray')
  document.getElementById('AddToCart').classList.remove('bg-black')
  document.getElementById('AddToCart').setAttribute('data-redirect', 'false')
  document.getElementById('AddToCart').innerHTML = productTranslations.addToCart

  const sizesWrapper = document.getElementById('quickview__product__sizes')
  sizesWrapper.innerHTML = ''
  sizes.sort((a, b) => (a.index > b.index ? 1 : -1))
  sizes.forEach(size => {
    const selectWidthConfig = {
      small: {
        width: 'w-10',
        unavailable: 'size__unavailable',
      },
      long: {
        width: 'w-20',
        unavailable: 'size__unavailable_long',
      },
    }
    const selectWidth = size.size.length <= 3 ? selectWidthConfig['small'] : selectWidthConfig['long']
    const multiSizeClass = isMultiSize(size.size) ? 'quickview__size__selector--multi' : ''
    const sizeWrapper = createElement(
      'div',
      `quickview__size__selector ${multiSizeClass} block cursor-pointer lg:hover:bg-dirty-gray lg:hover:text-white lg:hover:border-dirty-gray uppercase border border-black rounded-full h-10 ${selectWidth.width} text-center leading-none relative text-xs  mr-2 mb-2`,
      [{ name: 'data-size', value: size.size }]
    )

    !size.available && sizeWrapper.classList.add('opacity-40', selectWidth.unavailable)

    const sizeSphere = createElement(
      'div',
      `quickview__size__value absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 hover:text-white uppercase pointer-events-none text-black`
    )
    sizeSphere.innerHTML = size.size
    sizeWrapper.appendChild(sizeSphere)
    sizeWrapper.addEventListener('click', e => switchSelectedSize(e))
    sizesWrapper.appendChild(sizeWrapper)
  })
  productInfo.currentSizes = sizes

  // const notifyButton = document.querySelector(".restock-alerts-notify-button");
  // if (notifyButton) {
  //   notifyButton.classList.add("hidden");
  // }
}

const createElement = (type, classes, attr) => {
  const element = document.createElement(type)
  element.className = classes
  attr &&
    attr.forEach(attribute => {
      element.setAttribute(attribute.name, attribute.value)
    })
  return element
}

const switchSelectedSize = e => {
  observer && observer.disconnect()

  productInfo.selectedSize = e.target.getAttribute('data-size')
  Array.from(document.querySelectorAll('.quickview__size__selector')).forEach(sizeSelector => {
    sizeSelector.classList.remove('bg-black')
    sizeSelector.classList.add('bg-white')
  })
  Array.from(document.querySelectorAll('.quickview__size__selector div')).forEach(sizeSelector => {
    sizeSelector.classList.remove('text-white')
  })
  e.target.classList.add('bg-black')
  e.target.classList.remove('bg-white')
  e.target.querySelector('div').classList.add('text-white')
  e.target.querySelector('div').classList.remove('text-black')

  const selectedSize = productInfo.currentProductVariants.find(
    item =>
      item.variant.option1.toString().toLowerCase() == productInfo.selectedSize.toLowerCase() &&
      item.variantInfo.sku_frontend == productInfo.selectedColor
  )

  const shopLocationUrl = new URL(window.location.href)
  history.pushState(
    '',
    '',
    `${shopLocationUrl.origin}/products/${productInfo.variants[0].product.handle}?variant=${selectedSize.variant.id}`
  )

  const notifyButton = document.querySelector('.restock-alerts-notify-button')
  if (!selectedSize.variant.available) {
    document.getElementById('AddToCart').classList.add('hidden')
    notifyButton && notifyButton.classList.remove('hidden')
  } else {
    document.getElementById('AddToCart').classList.remove('hidden')
    notifyButton && notifyButton.classList.add('hidden')
  }

  // fillQuickViewFields(selectedSize.variant.id)

  const selection = document.getElementById('productSelect')
  selection.innerHTML = ''

  const option = createElement('option', '', [{ name: 'value', value: selectedSize.variant.id }])
  option.selected = 'selected'
  option.innerHTML = selectedSize.variant.option1
  selection.appendChild(option)
  document.getElementById('AddToCart').disabled = false
  selectedSize.variant.available && document.getElementById('AddToCart').classList.remove('bg-dark-gray')
  selectedSize.variant.available && document.getElementById('AddToCart').classList.add('bg-black')
  selectedSize.variant.available && document.getElementById('AddToCart').setAttribute('data-redirect', 'false')
  document.getElementById('AddToCart').innerHTML = selectedSize.variant.available
    ? productTranslations.addToCart
    : productTranslations.outOfStock

  if (selectedSize.variant.available) {
    document.getElementById('AddToCart').classList.remove('pointer-events-none')
  } else {
    document.getElementById('AddToCart').classList.add('pointer-events-none')
  }

  const wishlistButton = document.querySelector('.btn__wishlist')
  wishlistButton.setAttribute('data-id', selectedSize.variant.id)
  isProductInWishlist(wishlistButton)
}

const fillQuickViewInitialData = currentVariant => {
  if (!currentVariant) {
    console.log('no currentVariant?')
    return
  }

  // console.log('fillQuicviewInitialdata')
  // console.log(currentVariant)
  const notifyButton = document.querySelector('.restock-alerts-notify-button')
  if (!currentVariant.variant.available) {
    document.getElementById('AddToCart').classList.add('hidden')
    notifyButton && notifyButton.classList.remove('hidden')
  } else {
    document.getElementById('AddToCart').classList.remove('hidden')
    notifyButton && notifyButton.classList.add('hidden')
  }

  // const isImageInZoom = (mediaSrc, sku) => {
  //  **DEPRECATED**
  //   return (
  //     mediaSrc.toLowerCase().includes(sku.toLowerCase()) ||
  //     mediaSrc.toLowerCase().includes(sku.toLowerCase().replace('/', ''))
  //   )
  // }

  const sideImagesContainer = document.getElementById('quickview__side__images')
  sideImagesContainer.innerHTML = ''
  zoomImages = []
  productInfo.currentProductVariants[0].product.media.forEach(media => {
    zoomImages.push({
      src: media.src,
      h: window.innerHeight * 2,
      w: (window.innerHeight * 2) / media.aspect_ratio,
    })
  })

  // const spliderImagesCounter = splider.Components.Elements.length

  const productImages = productInfo.currentProductVariants[0].product.images

  if (productImages.length == 0) {
    if (currentVariant.variant.featured_image) {
      productImages.push(currentVariant.variant.featured_image.src)
    } else {
      productImages.push(currentVariant.product.featured_image)
    }
  }

  // Svuoto lo slider

  const numSlides = document.querySelectorAll('.splide__slide').length
  for (const slideIndex = numSlides - 1; slideIndex >= 0; slideIndex--) {
    splider.remove(slideIndex)
  }

  setTimeout(() => {
    productImages.forEach(image => {
      const imageWrapper = createElement('div', 'block mb-4 w-full aspect-w-10 aspect-h-12')
      const smallImageUrl = resizeImage(image, '150x200')
      const imageRect = createElement('img', 'cursor-pointer object-cover', [
        {
          name: 'src',
          value: smallImageUrl,
        },
      ])

      imageWrapper.addEventListener('click', e => {
        document.getElementById('quickview__main__image').setAttribute('src', image)
      })

      const slideImageWrapper = createElement('li', 'splide__slide')
      const slideImage = createElement('img', 'w-full h-auto', [{ name: 'src', value: image }])

      imageWrapper.appendChild(imageRect)
      sideImagesContainer.appendChild(imageWrapper)
      slideImageWrapper.appendChild(slideImage)
      splider.add(slideImageWrapper)
      slideImageWrapper.addEventListener('click', e => initPhotoSwipe())
    })
  }, 0)

  const mainImageContainer = document.getElementById('quickview__main__image')
  if (currentVariant.variant.featured_image) {
    mainImageContainer.setAttribute('src', currentVariant.variant.featured_image.src)
  } else {
    mainImageContainer.setAttribute('src', currentVariant.product.featured_image)
  }

  sideImagesContainer.style.height = mainImageContainer.clientWidth * 1.2 + 'px'

  const composition = document.querySelector('.product__info__composition')
  const fit = document.querySelector('.product__info__fit')
  const productCare = document.querySelector('.product__info__productCare')

  const productInfoWrapper = document.querySelector('.product__info')
  console.log(productInfo)
  if (productInfoWrapper) {
    productInfoWrapper.innerHTML = productInfo.variants[0].product.description

    if (productInfo.metaInfo.material && composition) {
      composition.innerHTML = productInfo.metaInfo.material
    } else {
      removeProductInfoDetails(composition)
    }

    if (productInfo.metaInfo.fit && fit) {
      fit.innerHTML = productInfo.metaInfo.fit
    } else {
      removeProductInfoDetails(fit)
    }

    if (productInfo.metaInfo.wash && productCare) {
      productCare.innerHTML = productInfo.metaInfo.wash
    } else {
      removeProductInfoDetails(productCare)
    }
  }
}

const removeProductInfoDetails = node => {
  if (node && node.closest('.product__info__details')) {
    node.closest('.product__info__details').remove()
  }
}

const addToCart = e => {
  e.preventDefault()
  const cartButton = document.getElementById('AddToCart')
  const redirectLocation = cartButton.getAttribute('data-redirect')
  if (redirectLocation != 'false') {
    window.location.href = redirectLocation
  } else {
    const data = Object.fromEntries(new FormData(document.getElementById('AddToCartForm')).entries())

    const formData = {
      items: [
        {
          id: data.id,
          quantity: data.quantity,
        },
      ],
    }
    fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(formData),
    })
      .then(response => response.json())
      .then(data => {
        const imageWrapper = document.createElement('div')
        imageWrapper.className = 'absolute block top-0 left-0 bg-black w-full h-full'
        const image = document.createElement('img')
        image.setAttribute('src', 'https://cdn.shopify.com/s/files/1/0580/8996/3676/files/addedToCart.svg?v=1626705416')
        image.className = 'absolute block top-1/2 left-1/2 transform -translate-y-1/2 -translate-x-1/2'
        imageWrapper.appendChild(image)
        cartButton.appendChild(imageWrapper)

        setTimeout(() => {
          cartButton.innerHTML = productTranslations.viewCart
          cartButton.classList.add('bg-black')
          cartButton.setAttribute('data-redirect', `/cart`)
        }, 1000)
        checkCartItems()
        try {
          getCartItems()
        } catch (err) {
          console.log(err)
        }
        // else if (data.hasOwnProperty("status")) {

        // }
      })
  }
}

const checkIfFooterInViewport = e => {
  if (window.innerWidth < 1024) {
    const footerBoundingRectClient = document.getElementById('shopify-section-megafooter').getBoundingClientRect()
    const restockButton = document.querySelector('.restock-alerts-notify-button')
    // // if (footerBoundingRectClient.y < window.innerHeight) {
    // //   document.getElementById('AddToCart').classList.add('hidden')
    // // } else {
    // //   document.getElementById('AddToCart').classList.remove('hidden')
    // // }
  }
}

const checkCartItems = () => {
  fetch('/cart.js')
    .then(response => response.json())
    .then(data => {
      const cartIcon = Array.from(document.querySelectorAll('.cartItems'))
      cartIcon.forEach(icon => {
        icon.innerHTML = data.items.length
      })
    })
}

const isProductInWishlist = async wishlistButton => {
  const productId = wishlistButton.getAttribute('data-id')
  let wishlist = localStorage.getItem('wpWishlistItems')
  if (!wishlist) {
    wishlistButton.setAttribute(
      'src',
      'https://cdn.shopify.com/s/files/1/0580/8996/3676/files/addToWishlist.svg?v=1625561332'
    )
  } else {
    wishlist = JSON.parse(wishlist)
    const isItemInWishlist = wishlist.find(item => item.id == productId)
    if (isItemInWishlist) {
      wishlistButton.setAttribute(
        'src',
        'https://cdn.shopify.com/s/files/1/0580/8996/3676/files/addedToWishlist.svg?v=1625561332'
      )
    } else {
      wishlistButton.setAttribute(
        'src',
        'https://cdn.shopify.com/s/files/1/0580/8996/3676/files/addToWishlist.svg?v=1625561332'
      )
    }
  }
}

const wishlistManagement = async e => {
  const data = await fetch(`/products/${e.target.getAttribute('data-handle')}.js`)
    .then(response => response.json())
    .then(data => {
      return data
    })

  if (data) {
    let wishlist = localStorage.getItem('wpWishlistItems')
    let variantToSave = data.variants.find(item => item.id == e.target.getAttribute('data-id'))
    variantToSave = {
      ...variantToSave,
      product: {
        title: data.title,
        vendor: data.vendor,
        url: data.url,
        id: data.id,
        handle: data.handle,
      },
    }
    if (!wishlist) {
      wishlist = [variantToSave]
    } else {
      wishlist = JSON.parse(wishlist)
      const isItemInWishlist = wishlist.find(item => item.id == variantToSave.id)

      if (!isItemInWishlist) {
        wishlist.push(variantToSave)
        e.target.setAttribute(
          'src',
          'https://cdn.shopify.com/s/files/1/0580/8996/3676/files/addedToWishlist.svg?v=1625561332'
        )

        const reccomendationWishlistButtons = Array.from(
          document.querySelectorAll(`.shopify-section-reccomendations .btn__wishlist`)
        )
        reccomendationWishlistButtons.forEach(element => {
          if (element.getAttribute('data-id') == data.id) {
            element.setAttribute(
              'src',
              'https://cdn.shopify.com/s/files/1/0580/8996/3676/files/addedToWishlist.svg?v=1625561332'
            )
          }
        })
      } else {
        wishlist = wishlist.filter(item => item.id !== variantToSave.id)
        e.target.setAttribute(
          'src',
          'https://cdn.shopify.com/s/files/1/0580/8996/3676/files/addToWishlist.svg?v=1625561332'
        )

        const reccomendationWishlistButtons = Array.from(
          document.querySelectorAll(`.shopify-section-reccomendations .btn__wishlist`)
        )

        reccomendationWishlistButtons.forEach(element => {
          if (element.getAttribute('data-id') == data.id) {
            element.setAttribute(
              'src',
              'https://cdn.shopify.com/s/files/1/0580/8996/3676/files/addToWishlist.svg?v=1625561332'
            )
          }
        })
      }
    }
    localStorage.setItem('wpWishlistItems', JSON.stringify(wishlist))
  }
}

const toggleProductZoom = reveal => {
  if (reveal) {
    document.querySelector('.product__zoom').classList.remove('hidden')

    if (window.innerWidth < 1024) {
      zoomSplider.go(splider.index)
    } else {
      zoomSplider.go(0)
      const mainImageContainerSource = document.querySelector('#quickview__main__image').getAttribute('src')

      zoomSplider.Components.Elements.slides.forEach((slide, index) => {
        if (slide.querySelector('img').getAttribute('src') === mainImageContainerSource) {
          zoomSplider.go(index)
        }
      })
    }
  } else {
    document.querySelector('.product__zoom').classList.add('hidden')
    zoomSplider.go(0)
  }

  const container = document.querySelector('.zoom__slider__container')
  Array.from(document.querySelectorAll('.zoom__slider__container .splide__slide img')).forEach(img => {
    img.style.transform = `translateY(-${(img.clientHeight - container.clientHeight) / 2}px) translateX(${
      (img.clientWidth - container.clientWidth) / 2
    }px)`
  })
}

const prevElementZoomed = {
  element: null,
  boundingRectClient: null,
}

const handleImagePosition = e => {
  if (prevElementZoomed.element == null) {
    prevElementZoomed.element = e.target
    prevElementZoomed.boundingRectClient = e.target.getBoundingClientRect()
  } else {
    if (e.target.src != prevElementZoomed.element.src) {
      prevElementZoomed.element = e.target
      prevElementZoomed.boundingRectClient = e.target.getBoundingClientRect()
    }
  }

  if (window.innerWidth >= 1024) {
    const container = document.querySelector('.zoom__slider__container')

    const translationAt0PercentX = (prevElementZoomed.element.clientWidth - container.clientWidth) / 2
    const translationAt100Percent = prevElementZoomed.element.clientHeight - container.clientHeight //1124

    const deltaX = e.clientX - prevElementZoomed.boundingRectClient.left
    const deltaY = e.clientY - prevElementZoomed.boundingRectClient.top

    const percentageDeltaX = (deltaX * 100) / prevElementZoomed.boundingRectClient.width
    const percentageDeltaY = (deltaY * 100) / prevElementZoomed.boundingRectClient.height

    const mX = -translationAt0PercentX / 100
    const mY = -translationAt100Percent / 100

    const qX = translationAt0PercentX
    const qY = 0 // 0 perchè la retta incrocia l'asse y in 0,0

    const translationXAtPercentageDelta = mX * percentageDeltaX + qX + prevElementZoomed.boundingRectClient.left * 4
    const translationYAtPercentageDelta = mY * percentageDeltaY + qY //qy = 0 quindi non impatta sul calcolo

    translationXAtPercentageDelta = Math.round((translationXAtPercentageDelta + Number.EPSILON) * 100) / 100
    translationYAtPercentageDelta = Math.round((translationYAtPercentageDelta + Number.EPSILON) * 100) / 100

    e.target.style.transform = `translateY(${translationYAtPercentageDelta}px) translateX(${translationXAtPercentageDelta}px)`
  }
}

const initPhotoSwipe = () => {
  let startIndex = 0
  const pswpElement = document.querySelectorAll('.pswp')[0]

  if (window.innerWidth < 1024) {
    startIndex = splider.index
  } else {
    const mainImageContainerSource = document.querySelector('#quickview__main__image').getAttribute('src')

    zoomImages.forEach((item, index) => {
      //console.log(item.src, `https:${mainImageContainerSource}`);
      if (item.src == `https:${mainImageContainerSource}`) {
        startIndex = index
      }
    })
  }

  const options = {
    history: false,
    fullscreenEl: true,
    zoomEl: true,
    tapToClose: false,
    clickToCloseNonZoomable: false,
    index: startIndex,
  }

  const gallery = new PhotoSwipe(pswpElement, PhotoSwipeUI_Default, zoomImages, options)

  gallery.init()
  options.index = startIndex
}

const resizeImage = (imageUrl, size) => {
  return imageUrl.substring(0, imageUrl.lastIndexOf('.')) + `_${size}` + imageUrl.substring(imageUrl.lastIndexOf('.'))
}
const addMutationObserver = (selector, customCallback) => {
  const targetNode = document.querySelector(selector)
  if (targetNode) {
    const config = { attributes: true, childList: true, subtree: true }
    const callback = (mutationsList, observer) => {
      // Use traditional 'for loops' for IE 11
      for (const mutation of mutationsList) {
        if (mutation.type === 'childList') {
          customCallback()
        } else if (mutation.type === 'attributes') {
        }
      }
    }

    let observer = null
    observer = new MutationObserver(callback)
    observer.observe(targetNode, config)
  }
}
